var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 48,
    viewBox: "0 0 47 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.4088,
    cy: 24.0875,
    r: 23.4078,
    fill: "#F9F5DE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.863 15.276C19.8262 14.5212 19.7871 13.9182 19.7871 13.428C19.7871 11.9944 20.0128 11.7319 20.8804 11.3914C21.9365 11.2048 22.8043 11.1289 23.5569 11.1289C24.4244 11.1289 25.1402 11.2417 25.7452 11.3914C26.6868 11.5432 26.9142 12.6364 26.9142 13.6926C26.9142 14.1828 26.8384 14.673 26.7995 15.276V15.4646C26.6498 17.3126 25.6694 29.038 25.0274 30.207C24.652 30.8859 23.9732 31.2243 22.9538 31.2243H22.8043C21.7848 31.1874 21.2946 30.7731 21.1061 30.207C20.6917 29.077 19.863 15.276 19.863 15.276ZM25.4048 35.2586C25.4048 36.4276 24.576 37.5967 22.9929 37.5967C21.3705 37.5967 20.5789 36.4276 20.5789 35.2586C20.5789 34.0916 21.3705 32.9225 22.9929 32.8836C24.576 32.9225 25.4048 34.0916 25.4048 35.2586Z",
    fill: "#FF556A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.d0f772d66c0c0374cce7232ec3103039.svg";
export { ForwardRef as ReactComponent };